import React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ArticleIcon from '@mui/icons-material/Article'; // Medium ke liye logic icon
import { Link } from 'react-router-dom';
import { Chat, Copyright, LocalParking } from '@mui/icons-material';

const Community = () => {
    const socialLinks = [
        {
            name: 'Instagram',
            icon: <InstagramIcon className="icon" />,
            link: 'https://www.instagram.com/heyprompt.online/',
            desc: 'Visual tips & AI news.',
            color: 'var(--apk-primary)'
        },
        {
            name: 'WhatsApp',
            icon: <WhatsAppIcon className="icon" />,
            link: 'https://whatsapp.com/channel/0029VbC1oYP8vd1Q1P30gI1T',
            desc: 'Instant prompt updates.',
             color: 'var(--apk-primary)'
        },
        {
            name: 'Medium',
            icon: <ArticleIcon className="icon" />,
            link: 'https://heyprompt.medium.com/',
            desc: 'In-depth AI articles.',
             color: 'var(--apk-primary)'
        },
        {
            name: 'Product hunt',
            icon: <LocalParking className="icon" />,
            link: 'https://www.producthunt.com/products/hey-prompt',
            desc: 'launch and discover new tech products.',
             color: 'var(--apk-primary)'
        },
        {
            name: 'thedc',
            icon: <Copyright className="icon" />,
            link: 'https://buildifytool.cloud/',
            desc: 'Founded by CEOs & Owners.',
             color: 'var(--apk-primary)'
        },
        {
            name: 'Heyprompt GPTs',
            icon: <Chat className="icon" />,
            link: 'https://chatgpt.com/g/g-69bb0fc79b68819189abb80ee1726406-heyprompt',
            desc: 'Heyprompt GPTs',
             color: 'var(--apk-primary)'
        },
    ];

    return (
        <section className="community-section-link">
            <div className="__container">
                <h2 className="title">Join the <span>HeyPrompt</span> Community</h2>
                <p className="subtitle">Connect with us across platforms and master the art of prompting.</p>

                <div className="row row-gap-4 justify-content-center">
                    {socialLinks.map((item, index) => (
                        <div className='col-4' key={index}>
                            <Link to={item.link}  target="_blank" rel="noreferrer" className="card">
                                <div className="icon-wrapper" style={{ color: item.color }}>
                                    {item.icon}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.desc}</p>
                                <span className="cta-text">.....</span>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Community;